const DefaultData = {
    APISERVERURL: 'https://b2cclienttravel.azurewebsites.net/api/',
    APILOCALURL: 'http://localhost:5126/api/',
    APIACTIVEURL: 'https://zotraiapi.azurewebsites.net/api/',
    DEFAULTPAYMENTGATEWAYFEE: 2.5,
    DEFAULTCURRENCY: 'INR',
    DEFAULTCOMPANYNAME: 'SAAR DEVELOPERS CODE PRIVATE LIMITED',
    DEFAULTBRANDNAME: 'ZOTRAI',
    USERTYPE: "CUSTOMER",
};

export default DefaultData;